import React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { push } from 'connected-react-router';

// Types
import SimpleArtist from '@common/types/artist/simple-artist';
import CatalogRelease from '@common/types/catalog/catalog-release';
import { openRelease } from '@webapp/utils/release/open-release';

import { ConfirmTakedownRelease } from '@webapp/store/release/action-creators';

// Store
import AppState from '@webapp/store/state';
import {
  CancelPendingTakedown,
  CancelRelease,
  LoadRelease,
} from '@webapp/store/release/action-creators';
import { OpenMenu } from '@webapp/store/ui/action-creators';

import MobileInfoRow from './mobile-row/info-row';
import DesktopInfoRow from './desktop-view/info-row';
import moment from 'moment';

declare type CatalogInfoRowProps = {
  user: any;
  item: CatalogRelease;
  release: CatalogRelease | undefined;
  artist: SimpleArtist;
  isMobile: boolean;
  isReleases: boolean;
  isTrackListOpen: boolean;
  isFilteredByAddedDate: boolean;
  openTrackList: () => void;
  handleCatalogMenu: (
    action: string,
    release: CatalogRelease,
    artist: SimpleArtist,
    user: any
  ) => void;
  showNotifications: () => OpenMenu;
  openDealForRelease: () => OpenMenu;
};

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  handleCatalogMenu: (
    action: string,
    release: CatalogRelease,
    artist: SimpleArtist
  ) => {
    switch (action) {
      case 'edit':
        dispatch(openRelease(release.artist.id, release.id, 'title'));
        return;
      case 'cancel-release':
        dispatch(new CancelRelease(release.artist.id, release.id));
        return;
      case 'upgrade-release':
        dispatch(push(`/upgrade-release/${release.artist.id}/${release.id}`));
        return;
      case 'take-down':
        dispatch(push(`/takedown-release/${release.id}/${release.artist.id}`));
        return;
      case 'cancel-take-down':
        dispatch(new CancelPendingTakedown(release.artist.id, release.id));
        return;
      case 'correct-artist-profile':
        dispatch(
          push(
            `/release/${release.artist.id}/${release.id}/streaming-platforms`
          )
        );
        return;
      case 'repair':
        dispatch(new LoadRelease(release.artist.id, release.id));
        dispatch(push(`/catalog/repair-release`));
        return;
      case 'copy-traclink':
        if (window.navigator?.clipboard && release.tracLink) {
          window.navigator.clipboard.writeText(release.tracLink);
        }
        return;
      case 'delete-release':
        dispatch(
          new ConfirmTakedownRelease(
            release.artist.id,
            release.id,
            release.title,
            true
          )
        );
        return;
      case 'manage-ownership':
        dispatch(
          push(
            `/user-profile/change-split/track/${release.id}/${
              release?.tracks[0]?.id
            }/${release?.tracks[0]?.name}/${artist.type}/${
              release?.release_date
                ? moment(moment(release.release_date).add(30, 'days')).diff(
                    moment()
                  ) > 0
                  ? 'FALSE'
                  : 'TRUE'
                : 'FALSE'
            }`
          )
        );
        return;
      default:
        return;
    }
  },
  showNotifications: () => dispatch(new OpenMenu('NOTIFICATIONS_MENU')),
  openDealForRelease: () => dispatch(new OpenMenu('DEAL_DETAILS', true)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(function CatalogInfoRow({
  user,
  item,
  release,
  artist,
  isReleases,
  isMobile,
  isTrackListOpen,
  isFilteredByAddedDate,
  openTrackList,
  handleCatalogMenu,
  showNotifications,
  openDealForRelease,
}: CatalogInfoRowProps) {
  return isMobile ? (
    <MobileInfoRow
      item={item}
      user={user}
      release={release}
      artist={artist}
      isReleases={isReleases}
      isTrackListOpen={isTrackListOpen}
      openTrackList={openTrackList}
      handleCatalogMenu={handleCatalogMenu}
      showNotificationMenu={showNotifications}
      isFilteredByAddedDate={isFilteredByAddedDate}
      openDealForRelease={openDealForRelease}
    />
  ) : (
    <DesktopInfoRow
      item={item}
      release={release}
      user={user}
      artist={artist}
      isReleases={isReleases}
      isTrackListOpen={isTrackListOpen}
      openTrackList={openTrackList}
      handleCatalogMenu={handleCatalogMenu}
      showNotificationMenu={showNotifications}
      openDealForRelease={openDealForRelease}
    />
  );
});
